/* metro-ui-components@9.20.0 */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
var React = require("react");
var IconSVG = /** @class */ (function (_super) {
    tslib_1.__extends(IconSVG, _super);
    function IconSVG() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IconSVG.prototype.render = function () {
        return (React.createElement("svg", tslib_1.__assign({ role: "img", viewBox: "0 0 80 80" }, this.props),
            React.createElement("path", { d: "m16.6211 27.0337c-.649.501-1.555.501-2.203 0-.501-.649-.501-1.554 0-2.203l24.53-24.53.501-.301h1.201l.501.301 24.531 24.53c.501.649.501 1.554 0 2.203-.635.539-1.568.539-2.203 0l-21.927-22.027v56.37c0 .829-.672 1.502-1.502 1.502-.829 0-1.502-.673-1.502-1.502v-56.37zm63.479 34.744v6.708c-.054 6.337-5.178 11.46-11.514 11.514h-57.071c-6.337-.054-11.46-5.177-11.515-11.514v-6.708c0-.83.673-1.502 1.502-1.502s1.502.672 1.502 1.502v6.708c0 4.7 3.81 8.51 8.511 8.51h57.071c4.7 0 8.511-3.81 8.511-8.51v-6.708c0-.83.671-1.502 1.502-1.502.829 0 1.501.672 1.501 1.502z" })));
    };
    return IconSVG;
}(React.Component));
exports.IconSVG = IconSVG;